import { FC } from "react"
import { SchedulesBatchDelete } from "../../../module/schedules/containers/batchDelete/index"

export const SchedulesBatchDeletePage: FC = () => <SchedulesBatchDelete />
